import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-blue-900 text-white" data-id="element-10">
      <div className="container mx-auto px-4 lg:px-8 py-12" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-12">
          {/* Company Info */}
          <div data-id="element-13">
            <h3 className="text-xl font-bold mb-4" data-id="element-14">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iJtC9QLhXWZPi7KGSWTJDn/Swastik_Infra_%284%29.png" alt="Swastik Infra Developers Logo" className="h-12 w-auto mb-4" data-id="element-15" />
            </h3>
            <p className="text-blue-100 mb-4" data-id="element-16">
              Building excellence through innovation, quality, and customer
              satisfaction. Established in 2024.
            </p>
            <div className="flex space-x-4" data-id="element-17">
              <a href="https://www.instagram.com/swastik.infra.developers" target="_blank" rel="noopener noreferrer" className="p-2 bg-blue-800 hover:bg-blue-700 rounded-full transition-colors" data-id="element-18">
                <InstagramIcon className="h-5 w-5" data-id="element-19" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-20">
            <h3 className="text-lg font-bold mb-4" data-id="element-21">Quick Links</h3>
            <ul className="space-y-2" data-id="element-22">
              <li data-id="element-23">
                <a href="#home" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-24">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-25" />
                  Home
                </a>
              </li>
              <li data-id="element-26">
                <a href="#about" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-27">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-28" />
                  About Us
                </a>
              </li>
              <li data-id="element-29">
                <a href="#projects" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-30">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-31" />
                  Projects
                </a>
              </li>
              <li data-id="element-32">
                <a href="#careers" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-33">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-34" />
                  Careers
                </a>
              </li>
              <li data-id="element-35">
                <a href="#contact" className="text-blue-100 hover:text-white transition-colors flex items-center" data-id="element-36">
                  <ArrowRightIcon className="h-3 w-3 mr-2" data-id="element-37" />
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-38">
            <h3 className="text-lg font-bold mb-4" data-id="element-39">Contact Information</h3>
            <ul className="space-y-3" data-id="element-40">
              <li className="flex" data-id="element-41">
                <MapPinIcon className="h-5 w-5 mr-3 flex-shrink-0 text-blue-300" data-id="element-42" />
                <span className="text-blue-100" data-id="element-43">
                  House No. 1006, Bolinj, Sopara Road, Next to Bharat Gas, Opp.
                  Karmale Talav, Bolinj, Virar(W) 401203
                </span>
              </li>
              <li className="flex" data-id="element-44">
                <PhoneIcon className="h-5 w-5 mr-3 flex-shrink-0 text-blue-300" data-id="element-45" />
                <span className="text-blue-100" data-id="element-46">
                  +91 9823446128
                  <br data-id="element-47" />
                  +91 8208381247
                </span>
              </li>
              <li className="flex" data-id="element-48">
                <MailIcon className="h-5 w-5 mr-3 flex-shrink-0 text-blue-300" data-id="element-49" />
                <span className="text-blue-100" data-id="element-50">swastikinfra900@gmail.com</span>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-51">
            <h3 className="text-lg font-bold mb-4" data-id="element-52">Newsletter</h3>
            <p className="text-blue-100 mb-4" data-id="element-53">
              Subscribe to our newsletter for latest updates on projects and
              offers.
            </p>
            <form className="flex flex-col space-y-2" data-id="element-54">
              <input type="email" placeholder="Your email address" className="px-4 py-2 bg-blue-800 border border-blue-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-blue-300" data-id="element-55" />
              <button type="submit" className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded font-medium transition-colors" data-id="element-56">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="bg-blue-950 py-4" data-id="element-57">
        <div className="container mx-auto px-4 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-58">
          <p className="text-blue-200 text-sm" data-id="element-59">
            &copy; {new Date().getFullYear()} Swastik Infra Developers. All
            rights reserved.
          </p>
          <div className="flex space-x-4 mt-2 md:mt-0" data-id="element-60">
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-61">
              Privacy Policy
            </a>
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-62">
              Terms of Use
            </a>
            <a href="#" className="text-blue-200 hover:text-white text-sm transition-colors" data-id="element-63">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;